import React from 'react';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import L from 'leaflet';
import customLogo from '../assets/custom-logo.png';

const customIcon = L.icon({
    iconUrl: customLogo,
    iconSize: [40, 50],
    iconAnchor: [15, 40],
    popupAnchor: [0, -35]
  });

const ParkingMap = ({ parkingData }) => {
  return (
    <MapContainer center={[55.6761, 12.5683]} zoom={13} style={{ height: '100vh', width: '100%' }}>
      <TileLayer
        url="https://tiles.jfmtech.dk/styles/osm-bright/{z}/{x}/{y}.png"
        attribution='&copy; OpenStreetMap contributors, Tiles &copy; JFM'
      />
      {parkingData.map((station, idx) => {
        // Parse coords if they are stored as a string
        const coords = JSON.parse(station.coords);
        return (
          <Marker key={idx} position={coords} icon={customIcon} >
            <Popup>
              <strong>Gade: {station.gade}</strong><br />
              Antal Gratis Parkeringspladser: {station.sum}
            </Popup>
          </Marker>
        );
      })}
    </MapContainer>
  );
};

export default ParkingMap;
